import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '@api/urls';
import { keepDataPerSeconds } from '@redux/constants/queryConfig';
import { baseQuery } from '../baseQuery';
import { TCreateTransactionRequest, TCreateTransactionResponse } from './types';

export const paymentApi = createApi({
    baseQuery,
    reducerPath: 'paymentApi',
    keepUnusedDataFor: keepDataPerSeconds.paymentApi,
    refetchOnReconnect: true,
    endpoints: build => ({
        createTransaction: build.mutation<TCreateTransactionResponse, TCreateTransactionRequest>({
            query: (data: TCreateTransactionRequest) => {
                return {
                    url: urls.payment.createTransaction,
                    method: 'POST',
                    body: data,
                };
            },
            transformResponse: (response: TCreateTransactionResponse) => response,
        }),
    }),
});

export const { useCreateTransactionMutation, util: paymentApiUtil } = paymentApi;
